import { useState, useEffect } from 'react';
import api from '../../servicios/api';

const CARGO_COLORS = {
  'Administrador': '#111827',
  'Supervisor':    '#7c3aed',
  'Inspector':     '#0891b2',
  'Bodeguero':     '#059669',
  'Operador':      '#d97706',
};

const cargoColor = (cargo) => CARGO_COLORS[cargo] || '#6b7280';

const TabProyectosEquipo = ({ onAbrirProyecto }) => {
  const [datos, setDatos] = useState(null);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    api.get('/dashboard/global')
      .then(r => setDatos(r.data))
      .catch(() => setError('No se pudieron cargar los proyectos'))
      .finally(() => setCargando(false));
  }, []);

  if (cargando) {
    return (
      <div className="tab-content">
        <section className="progress-section-v2">
          <div className="critical-header-bar">
            <span className="progress-badge" style={{ background: '#111827' }}>PROYECTOS</span>
          </div>
          <p style={{ color: '#6b7280', padding: '32px', textAlign: 'center' }}>Cargando proyectos...</p>
        </section>
      </div>
    );
  }

  if (error) {
    return (
      <div className="tab-content">
        <section className="progress-section-v2">
          <p style={{ color: '#ef4444', padding: '32px', textAlign: 'center' }}>{error}</p>
        </section>
      </div>
    );
  }

  const proyectos = datos?.proyectos || [];


  return (
    <div className="tab-content">
      {/* ── SECCIÓN PROYECTOS ── */}
      <section className="progress-section-v2">
        <div className="critical-header-bar">
          <span className="progress-badge" style={{ background: '#111827' }}>PROYECTOS</span>
          <span className="progress-header-date">
            {proyectos.length} proyecto{proyectos.length !== 1 ? 's' : ''}
          </span>
        </div>

        {proyectos.length === 0 ? (
          <p style={{ color: '#6b7280', padding: '32px', textAlign: 'center' }}>
            No hay proyectos registrados
          </p>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', marginTop: '16px' }}>
            {proyectos.map((item) => {
              const p = item.proyecto;
              const miembros = item.miembros || [];
              const pid = p.id || p._id;
              const estadoColor = p.estado === 'activo' ? '#10b981' : p.estado === 'pausado' ? '#f59e0b' : '#6b7280';

              return (
                <div
                  key={pid}
                  style={{
                    background: '#fff',
                    border: '1px solid #e5e7eb',
                    borderRadius: '10px',
                    padding: '20px',
                    boxShadow: '0 1px 4px rgba(0,0,0,0.06)'
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: '12px', marginBottom: '16px' }}>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                        <h3 style={{ margin: 0, fontSize: '15px', fontWeight: '700', color: '#111827', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                          {p.nombre}
                        </h3>
                        <span style={{
                          fontSize: '11px', fontWeight: '600', color: estadoColor,
                          background: `${estadoColor}18`, padding: '2px 8px',
                          borderRadius: '12px', textTransform: 'capitalize', flexShrink: 0
                        }}>
                          {p.estado || 'activo'}
                        </span>
                      </div>
                      {p.manager && (
                        <p style={{ margin: '4px 0 0', fontSize: '12px', color: '#6b7280' }}>
                          Manager: <strong>{p.manager}</strong>
                        </p>
                      )}
                    </div>
                    <button
                      onClick={() => onAbrirProyecto && onAbrirProyecto(p)}
                      style={{
                        padding: '7px 16px', background: '#111827', color: '#fff',
                        border: 'none', borderRadius: '6px', fontSize: '13px',
                        fontWeight: '600', cursor: 'pointer', flexShrink: 0
                      }}
                    >
                      Abrir
                    </button>
                  </div>

                  <div>
                    <p style={{ margin: '0 0 8px', fontSize: '12px', fontWeight: '600', color: '#374151', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                      Equipo · {miembros.length} miembro{miembros.length !== 1 ? 's' : ''}
                    </p>
                    {miembros.length === 0 ? (
                      <p style={{ margin: 0, fontSize: '12px', color: '#9ca3af', fontStyle: 'italic' }}>
                        Sin miembros registrados
                      </p>
                    ) : (
                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                        {miembros.map((m) => (
                          <div
                            key={m._id || m.email}
                            title={m.email || ''}
                            style={{
                              display: 'flex', alignItems: 'center', gap: '6px',
                              background: '#f9fafb', border: '1px solid #e5e7eb',
                              borderRadius: '20px', padding: '4px 10px 4px 4px', fontSize: '12px'
                            }}
                          >
                            <div style={{
                              width: '22px', height: '22px', borderRadius: '50%',
                              background: cargoColor(m.cargo), color: '#fff',
                              display: 'flex', alignItems: 'center', justifyContent: 'center',
                              fontSize: '10px', fontWeight: '700', flexShrink: 0
                            }}>
                              {(m.nombre || '?').charAt(0).toUpperCase()}
                            </div>
                            <span style={{ fontWeight: '500', color: '#111827' }}>{m.nombre}</span>
                            {m.cargo && (
                              <span style={{ color: cargoColor(m.cargo), fontWeight: '600', fontSize: '11px' }}>
                                · {m.cargo}
                              </span>
                            )}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </section>

    </div>
  );
};

export default TabProyectosEquipo;
